const youtubeVideoService = ({
  youtubeVideoId,
}: {
  youtubeVideoId: string;
}) => ({
  youtubeVideoId,
  isResponsive: true,
});

export default youtubeVideoService;
